export default __webpack_public_path__ + "static/img/src/components/Icon/Payment.svg";